import { useEffect, useState } from 'react'
import api from '../../../../services/api'
import { Avatar, Card, MenuItem, TextField } from '@mui/material'
import ButtonLeft from '../../../../utils/buttonLeft'
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs'
import { useDispatch, useSelector } from 'react-redux'
import MessageSuccess from '../../../../messages/messageSuccess'
import MessageError from '../../../../messages/messageError'

export default function AddAnalistaRevisor({ solicitacaoAnaliseId, productoId, setRefresh }) {
    const user = useSelector(state => state.account.user);
    const [admins, setAdmins] = useState('')
    const [analistaRevisor, setAnalistaRevisor] = useState('')
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()


    useEffect(() => {
        // api.get('/admins?funcao=CNP')
        api.get('/admins?departamento=DCQMTS')
            .then(response => {
                setAdmins(response.data.Admins)
            }).catch(err => '')
    }, [])

    function handleChange(e) {

        e.target.files ?
            setAnalistaRevisor({ ...analistaRevisor, [e.target.name]: e.target.files[0] })
            :
            setAnalistaRevisor({ ...analistaRevisor, [e.target.name]: e.target.value })
    }

    const handleAddAnalistaRevisor = async () => {
        setLoad(true)
        setMessageSuccess('')
        setMessageError('')

        await api.post('/avalicao-analitica/create',
            {
                ...analistaRevisor,
                productoId,
                solicitacaoAnaliseId,
                userId: user._id
            })
            .then(res => {
                // console.log(res)
                setLoad(false);
                setMessageSuccess(res.data.msg);
                setRefresh(res.data);

                dispatch({
                    type: 'alert',
                    payload: { alert: 'Analista e Revisor foram inseridos.!' },
                });

            }).catch(err => {
                // console.log(err)
                setLoad(false)
                setMessageError(err.response.data.message)
            })
    }


    return (
        <Card style={{ padding: 15, marginTop: 20 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs title={'Selecionar Analista e Revisor'} />

            <TextField
                margin='normal'
                required
                type="text"
                label="Selecionar Analista"
                select
                fullWidth
                size="small"
                name="analistaId"
                variant="outlined"
                onChange={handleChange}
                defaultValue={''}
            >
                {admins &&
                    admins.map((admin) => (
                        <MenuItem key={admin._id} value={admin._id} >
                            <Avatar src={admin.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                            {admin.dadosPessoais?.nome} - <b>{admin.dadosPessoais?.provincia}, {admin.dadosPessoais?.municipio}</b>
                        </MenuItem>
                    ))}
            </TextField>

            <TextField
                margin='normal'
                required
                type="text"
                label="Selecionar Revisor"
                select
                fullWidth
                size="small"
                name="revisorId"
                variant="outlined"
                onChange={handleChange}
                defaultValue={''}
            >
                {admins &&
                    admins.map((admin) => (
                        <MenuItem key={admin.dadosPessoais?._id} value={admin._id} >
                            <Avatar src={admin.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                            {admin.dadosPessoais?.nome} - <b>{admin.dadosPessoais?.provincia}, {admin.dadosPessoais?.municipio}</b>
                        </MenuItem>
                    ))}
            </TextField>

            <ButtonLeft
                title={'Adicionar'}
                funcao={handleAddAnalistaRevisor}
                load={load}
                disabled={!analistaRevisor.revisorId || !analistaRevisor.analistaId}
            />

        </Card>
    )
}
